import type { AiModelOption } from "@/lib/types"

/**
 * Espelho do registro do backend (apps/api/server/services/ai.ts).
 * Usado como fallback quando o painel ainda não recebeu os modelos da API.
 */
export const AI_MODEL_OPTIONS: AiModelOption[] = [
  {
    id: "gpt-6-luna",
    name: "GPT-6 Luna",
    description: "Raciocínio equilibrado para suporte do dia a dia.",
    context: "128k de contexto",
    usage: "Uso padrão",
  },
  {
    id: "gpt-5-mini",
    name: "GPT-5 Mini",
    description: "Respostas rápidas para triagem e perguntas frequentes.",
    context: "128k de contexto",
    usage: "Uso econômico",
  },
  {
    id: "gpt-4.1",
    name: "GPT-4.1",
    description: "Contexto longo para docs, catálogo e casos complexos.",
    context: "1M de contexto",
    usage: "Uso avançado",
  },
]
